/* import __COLOCATED_TEMPLATE__ from './seller-profile-about.hbs'; */
import Component from '@glimmer/component';
import { createCache, getValue } from '@glimmer/tracking/primitives/cache';
import { inject as service } from '@ember/service';
import { makeMoney } from 'sh-www/helpers/make-money';

export default class SellerProfileAbout extends Component {
  @service session;
  @service router;

  #unusedServices = createCache(() => {
    const services = this.args.user.services;
    const serviceCompanyUserScoresMap = this.args.user.serviceCompanyUserScores.reduce((acc, serviceScore) => {
      acc[serviceScore.service.id] = true;
      return acc;
    }, new Map());

    return services.filter(service => !serviceCompanyUserScoresMap[service.id]);
  });

  get className() {
    return 'SH-c-seller-profile-freelancer-profile__about';
  }

  get unusedServices() {
    return getValue(this.#unusedServices);
  }

  get canViewEarnings() {
    const currentUser = this.session.currentUser;
    return currentUser.isAdmin || currentUser.isCompanyAdmin;
  }

  get earningsYearToDate() {
    const earnings = this.args.currentCompanyConnection?.ytdEarningsInCents;
    if (earnings == null) return "-";
    return makeMoney([(earnings / 100).toFixed(2)]);
  }

  get earningsAllTime() {
    const earnings = this.args.currentCompanyConnection?.lifetimeEarningsInCents;
    if (earnings == null) return "-";
    return makeMoney([(earnings / 100).toFixed(2)]);
  }

  get languagesString() {
    const languagesArray = this.args.user.profile.languages.map((language) => {
      return language.name;
    });
    return languagesArray.join(" • ");
  }
}
